(ns ycweb.app.website.registry.common
  (:require
   #?@(:cljs
       [[ajax.core :as ajax]])
   [api.products.helpers :as helpers]
   [rum.core :as rum]
   [ycweb.app.website.cards :as cards]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(defn registry-item-line [app-atom edit-mode? registry-item]
  (let [{:item-line/keys [variation]
         :registry-item/keys [needed-qty paid-for-qty hide?]} registry-item]
    (cond
      edit-mode?
      (cards/registry-product-card app-atom edit-mode? registry-item)

      (and
        (or
          (and needed-qty (pos? needed-qty))
          (and paid-for-qty (pos? paid-for-qty)))
        (not (contains? #{"REGMON" "DVCH"} (:variation/code variation)))
        (or (not hide?) (and paid-for-qty (pos? paid-for-qty))))
      (cards/registry-product-card app-atom edit-mode? registry-item))))

(rum/defcs category-view < rum/reactive (rum/local {:active? true} ::local)
  [s app-atom edit-mode? [category items]]
  (let [local-atom (::local s)
        {:keys [active?]} (rum/react local-atom)
        item-count (count items)]
    (when (or edit-mode? (pos? item-count))
      [:div.accordion
       {:key (:name category)}
       [:h2.accordion__heading
        [:a
         {:on-click #(swap! local-atom update :active? not)
          :class (u/bem :accordion__heading-link [(when active? :is-active)])}
         [:span.accordion__heading-text (:name category)]
         [:span.accordion__heading-count
          [:span {:class (u/bem :text-pill [:default :dark])} item-count]]
         [:span.accordion__heading-icon-wrapper
          [:i.accordion__heading-icon {:class (u/bem :icon [(if active? :minus :plus) :is-dark :default :block])}]]]]
       [:div
        {:class (u/bem :accordion__content-wrapper [(when active? :is-open)])}
        [:div.accordion__content
         [:div
          {:class (u/bem :flex-grid-group [:align-left])}
          (map
            (fn [item]
              (registry-item-line app-atom edit-mode? item))
            items)]

         (when edit-mode?
           [:div.flex-grid-block.flex-grid-block--full
            [:div.flex-grid-content
             [:div.u-block-center.u-max-width-320.u-margin-top-20.u-margin-bottom-20
              [:a.button.button--default.button--raised.button--full.button--secondary.button--bordered.button--has-icon-left
               {:href (helpers/page-url (:name category))}
               [:span.button__text
                [:i.icon.icon--plus-circle.icon--is-dark.icon--default.icon--block.button__icon]
                (str "Add " (when (pos? item-count) "more ") (:name category))]]]]])]]])))

(defn default-view [app-atom edit-mode? items]
  [:div
   {:class (u/bem :flex-grid-group [:align-left])}
   (map
     (fn [item]
       (registry-item-line app-atom edit-mode? item))
     items)])

(defn group-by-cat [categories items]
  (let [grouped-items (group-by (comp :product/top-level-category :item-line/product) items)]
    (reduce
      (fn [acc category]
        (assoc acc category (sort-by :registry-item/purchased? (get grouped-items (:name category)))))
      {}
      categories)))

(rum/defc order-table < rum/reactive [app-atom edit-mode? items]
  (let [process-atom (cmn/process-cursor app-atom)
        categories (cmn/curact process-atom [:categories :categories])
        group-items-by-key (cmn/curact process-atom [:categories :group-items-by-key])
        sorted-items
        (case group-items-by-key
          "category"
          (sort-by #(:catlive (key %)) > (group-by-cat categories (vals items)))

          "priceLow"
          (sort-by
            (juxt :registry-item/price (comp :product/name-ex-brand :item-line/product))
            (vals items))

          "priceHigh"
          (sort-by
            (juxt :registry-item/price (comp :product/name-ex-brand :item-line/product))
            u/desc
            (vals items))

          "purchased"
          (sort-by
            (juxt :registry-item/purchased? :registry-item/price (comp :product/name-ex-brand :item-line/product))
            u/desc
            (vals items))

          (vals items))]
    [:div {:id "manage-products-wrapper"}
     [:div
      {:class (u/bem :yc-section [:standard])}
      (headings/heading "Our Wedding Gift List"
        {:type :h2
         :size :medium
         :center true})
      [:div
       [:div.form-field.u-block-center.u-max-width-480.u-text-center
        [:label.select__text "Sort Gifts by: "]
        [:div
         {:class (u/bem :select-wrapper [:inline])}
         (forms/select-raw
           (rum/cursor-in process-atom [:categories :group-items-by-key])
           [{:value "category" :text "Category"}
            {:value "priceLow" :text "Price: Low to High"}
            {:value "priceHigh" :text "Price: High to Low"}
            {:value "purchased" :text "Sort by Purchased"}])]]]

      (cond
        (= group-items-by-key "category")
        (map
          (fn [cat-items]
            (category-view app-atom edit-mode? cat-items))
          sorted-items)

        :else
        (default-view app-atom edit-mode? sorted-items))]]))

(rum/defc registry-manage-nav [app-atom nav-type registry & [process-atom]]
  [:div.group
   {:id "js-manage-button-bar"
    :class (u/bem :button-bar-wrapper [:center])}
   [:ul.group
    {:class (u/bem :button-bar [:fixed])}
    (when (= nav-type :close-view)
      [:li.button-bar__item
       [:a.button-bar__link
        (urlstate/href-props app-atom "myaccount" "registry")
        "Back to My Account"]])

    (when (= nav-type :edit-view)
      [:li.button-bar__item
       [:a.button-bar__link
        (urlstate/href-on-click
          (fn [e]
            (swap! process-atom assoc-in [:edit-details?] true)
            (scroll/scroll-to-id e "js-manage-form-wrapper")))
        "Edit Details"]])

    (when (= nav-type :edit-view)
      [:li.button-bar__item
       [:a.button-bar__link
        (urlstate/href-on-click
          #(scroll/scroll-to-id % "manage-products-wrapper"))
        [:span {:class (u/bem :clip-text [:t] :unclip-text [:s])} "View "] "Selection"]])

    (when (not= nav-type :edit-view)
      [:li.button-bar__item
       [:a.button-bar__link
        (urlstate/href-props app-atom "registry" "edit" {:uuid (:ent/uuid registry)})
        "Edit Registry"]])

    (when (not= nav-type :edit-view)
      [:li.button-bar__item
       [:a.button-bar__link.js-smoothscroll
        (urlstate/href-props app-atom "registry" "edit")
        [:span {:class (u/bem :clip-text [:t] :unclip-text [:s])} "View "] "Selection"]])

    [:li.button-bar__item
     [:a.button-bar__link
      (urlstate/href-props app-atom "registry" "view" {:uuid (:ent/uuid registry)})
      [:span
       {:class (u/bem :clip-text [:t] :unclip-text [:l])}
       "View in "]
      "Guest Mode"]]]

   [:ul.button-bar.group.js-button-nav
    [:li.button-bar__item
     [:a.button-bar__link
      (urlstate/href-props app-atom "products")
      "Add Products"
      [:i
       {:class (u/bem :icon [:inline :default :is-dark :chevron-down])}]]
     [:ul.button-bar__sub-menu
      [:li.button-bar__sub-menu-item
       [:a.button-bar__sub-menu-link
        (urlstate/href-props app-atom "registry" "collectionlist" {:registry-uuid (:ent/uuid registry)})
        "Starter Collections"]]
      [:li.button-bar__sub-menu-item
       [:a.button-bar__sub-menu-link
        (urlstate/href-props app-atom "top-sellers")
        "Customer Favourites"]]
      [:li.button-bar__sub-menu-item
       [:a.button-bar__sub-menu-link
        (urlstate/href-props app-atom "products")
        "All Products"]]]]
    [:li.button-bar__item
     [:a.button-bar__link.js-smoothscroll
      (urlstate/href-on-click #(scroll/scroll-to-id % "manage-products-wrapper"))
      "Manage"
      [:i
       {:class (u/bem :icon [:inline :default :is-dark :chevron-down])}]]
     [:ul.button-bar__sub-menu
      [:li.button-bar__sub-menu-item
       [:a.button-bar__sub-menu-link
        (urlstate/href-props app-atom "registry" "thankyoumanager" {:uuid (:ent/uuid registry)})
        "Thank You Manager"]]
      [:li.button-bar__sub-menu-item
       [:a.button-bar__sub-menu-link
        (urlstate/href-props app-atom "registry" "familydiscount" {:uuid (:ent/uuid registry)})
        "Family Discount"]]
      [:li.button-bar__sub-menu-item
       [:a.button-bar__sub-menu-link
        (urlstate/href-props app-atom "registry-how-it-works")
        "How it works"]]
      ;The close button needs to navigate to the close registry page
      [:li.button-bar__sub-menu-item
       [:a.button-bar__sub-menu-link
        (urlstate/href-on-click
          #(grid/open-modal app-atom :web.registry/close-registry-modal
             {:config
              {:title "Close Registry"
               :registry/uuid (:ent/uuid registry)}}))
        "Close Registry"]]]]]])

(def default-banner-id 1)

(rum/defc registry-banner < rum/reactive
  [app-atom registry & [edit-mode?]]
  (let [{:item-line/keys [user]
         :registry/keys [colour-palette partner background-id close-date] :as registry-banner-data} registry

        title
        (cond
          (and (u/presence (:user/first-name user)) (u/presence (:partner/first-name partner)))
          (str (:user/first-name user) " & " (:partner/first-name partner))

          (u/presence (:user/first-name user))
          (:user/first-name user))

        public-id (get-in registry [:ent/image :doc/public-id])]

    (web-common/set-meta-title! (str title " @ Yuppiechef"))
    [:div
     {:class [(str "u-bg-" (:colour/colour-name colour-palette)) (u/bem :header-banner [:has-avatar])]}
     [:div.header-banner__text-wrapper
      [:div.header-banner__text
       {:class (if (:colour/text-dark? colour-palette) "u-text-dark" "u-text-white")}
       [:div.header-banner__avatar
        [:img.header-banner__avatar.avatar
         {:src
          (u/cloudinary (or (u/presence public-id) "registries/default/registry_avatar_140_140") {:h 140 :w 140 :q "auto"})
          :alt "Your Photo"
          :class (u/bem :yc-simple-image [:shadow :border :full])}]]
       [:h1.header-banner__title title
        [:span.header-banner__subtitle
         [:span.u-hidden-from-view " — "]
         (ud/date-format (ud/coerce-date close-date) "dd MMM YYYY")]]]]
     [:div.header-banner__image-wrapper
      (web-common/lazy-image app-atom
        (str "pages/registry/wallpapers/registry-wallpaper-" (or background-id default-banner-id) ".jpg")
        {:class ["header-banner__image"]}
        {:w 960
         :mw 490
         :q "auto"
         :alt ""})]

     (when edit-mode?
       [:div.header-banner-edit-buttons
        [:div
         {:class (u/bem :flex-grid-group [:flush])}
         [:div
          {:class (u/bem :flex-grid-block [:t-1-2])}
          [:div.header-banner-edit-buttons__item.flex-grid-content
           (buttons/button-web "Upload Photo"
             (merge
               (urlstate/href-on-click #(grid/dispatch-action app-atom :web.registry/upload-photo-modal {}))
               {:style :secondary
                :size :small
                :full true}))]]
         [:div
          {:class (u/bem :flex-grid-block [:t-1-2])}
          [:div.header-banner-edit-buttons__item.flex-grid-content
           (buttons/button-web "Change Cover"
             (merge
               (urlstate/href-on-click #(grid/dispatch-action app-atom :web.registry/change-cover-modal {}))
               {:style :secondary
                :size :small
                :full true}))]]]])]))

(defn colour-look-up [background-id]
  (cond
    (contains? #{1 12 13 19  16} background-id)
    "malibu"
    (contains? #{2 14 17} background-id)
    "oil"
    (contains? #{15 18 23 24} background-id)
    "greenery"
    (contains? #{6 26 27} background-id)
    "terracotta"
    (contains? #{10 7 11 25} background-id)
    "peacock"
    (contains? #{5 21} background-id)
    "casablanca"
    (contains? #{8 20} background-id)
    "iris"
    (contains? #{22} background-id)
    "porcelain"
    :else
    "oil"))

(defn set-registry-session [client-order-id]
  #?(:cljs
     (when client-order-id
       (let [data (js/FormData.)]
         (.append data "selectedRegistryId" client-order-id)
         (ajax/POST
           "/registry.htm?action=SetSession"
           {:body data
            :response-format :json
            :keywords? true
            :handler (fn [res])
            :timeout 60000})))))
